export const MainRoutes = {
  HOME: '/',
  UPDATES: '/updates',
  BED_BOARD: '/bed-board',
  VERIFICATION: '/verifications',
  BURN_CENTERS: '/burn-centers',
  USERS: '/users',
  PROFILE: '/profile',
  REPORTS: '/reports',
  UPLOAD: '/data_uploaders',
  TRAINING: '/training',
  ADMIN: '/admin',
  RESTRICTED: '/restricted',
};

export const AppAdminRoutes = {
  HOME: 'dashboard',
  USERS: 'users',
  FORMS: 'forms',
  SITE_VISIT: 'site-visit',
  DOCS: 'documents',
  DETERMINATION: 'final-determination',
};

export const AdminRoutes = {
  MESSAGES: 'messages',
};

export const BurnCenterRoutes = {
  DETAIL: 'detail',
};

export const UsersRoutes = {
  DETAIL: 'detail',
};

export const FormRoutes = {
  initApp: 'initial-application',
  prq: 'prq',
  meetingRounds: 'meeting-rounds',
  keyFindings: 'key-findings',
  finalReport: 'site-report',
};

export const ReportRoutes = {
  MANAGE: 'manage',
  VIEW: 'view',
};

export const verificationRoutes = {
  REVIWER: 'reviewer',
  VERIFICATION: 'verification',
};
